/* unplugin-vue-components disabled */import { render } from "./ImageUploader.vue?vue&type=template&id=6c21e6fb&scoped=true&ts=true"
import script from "./ImageUploader.vue?vue&type=script&lang=ts"
export * from "./ImageUploader.vue?vue&type=script&lang=ts"

import "./ImageUploader.vue?vue&type=style&index=0&id=6c21e6fb&lang=scss&scoped=true"
import "./ImageUploader.vue?vue&type=style&index=1&id=6c21e6fb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c21e6fb"]])

export default __exports__